import { useNavigate, Link } from "react-router-dom";
import useLogout from "../hooks/useLogout";
import useAuth from "../hooks/useAuth";
import { Container, Row, Col, Form } from 'react-bootstrap';
import 'boxicons/css/boxicons.min.css';
import TopBar from "../pages/Admin/TopBar";
import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";



const SthanUserAddCategories = () => {
    const navigate = useNavigate();
    const logout = useLogout();
    const { auth } = useAuth();
    const [selectedCategories, setSelectedCategories] = useState("");
    const [categoriesList, setCategoriesList] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [errorMessage, setErrorMessage] = useState("");
    const UPDATE_STHAN_CATEGORY = "update-sthan-category";
    const [errMsg, setErrMsg] = useState("");
    const [sucssMsg, setSucssMsg] = useState("");
    const errRef = useRef();

    const signOut = async () => {
        await logout();
        navigate('/login');
    }


    const showMessage = (type, message) => {
        if (type === 'error') {
            setErrMsg(message);
            setSucssMsg(""); // ensure success message is cleared
        } else if (type === 'success') {
            setSucssMsg(message);
            setErrMsg(""); // ensure error message is cleared
        }

        // Auto-hide after 10 seconds
        setTimeout(() => {
            setErrMsg("");
            setSucssMsg("");
        }, 10000); // 10000ms = 10 seconds
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedCategories) {
            setErrorMessage("Please select a category.");
            return;
        } else {
            setErrorMessage(""); // clear any previous error

            try {
                var data = JSON.stringify({
                    sthan_id: auth.level_id,
                    category: selectedCategories,
                    setDefault: true

                });

                const response = await axiosPrivate.post(UPDATE_STHAN_CATEGORY, data, {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                });

                showMessage('success', response?.data?.message);
                // ✅ Redirect after successful update
                if (response?.status === 200) {
                    // Example URL — change this to your desired path
                    window.location.href = "/sthanDashboard";
                }

            } catch (err) {
                if (!err?.response) {
                    setErrMsg("No Server Response");
                } else if (err.response?.data?.message) {
                    const errorMsg = typeof err.response.data.message === 'string'
                        ? err.response.data.message
                        : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
                    setErrMsg(errorMsg);
                } else {
                    setErrMsg("Registration Failed");
                }
                errRef.current.focus();
            }
        }


    };

    const fetchSthanCategories = async () => {
        try {
            const response = await axiosPrivate.get('get-categories');
            setCategoriesList(response.data);

            // Set the default dropdown value to the first categories if available
            if (response.data.length > 0) {
                setSelectedCategories(response.data[0].categories);
            }
        } catch (error) {
            console.error("Error fetching categories list:", error);
        }
    };








    useEffect(() => {
        fetchSthanCategories();
    }, []);

    return (

        <Container>

            <section className="adminsec">

                <div className="center-image">

                    <img src="/images/newlogo.png" width="20%" className='' />
                </div>
                {/* <h1 className="adminhead">Dashbord</h1> */}
                <br />
                <center><h2 className="dashwel">NAMASTHE <span className="colorChange">{auth?.name}</span> !</h2> </center>



                <div className="spclrow">
                    <p className="dashwel">Sthan: {auth?.level_name}</p>
                    <form onSubmit={handleSubmit}>
                        {errorMessage && (
                            <p style={{ color: 'red', marginTop: '10px' }}>{errorMessage}</p>
                        )}
                        <Form.Control
                            as="select"
                            value={selectedCategories}
                            onChange={(e) => setSelectedCategories(e.target.value)}
                            className="vibhaglist"
                        >
                            <option value="">-- Select Sthan Categories--</option>
                            {categoriesList.map((category, index) => (
                                <option key={index} value={category}>
                                    {category}
                                </option>
                            ))}
                        </Form.Control>


                        <button type="submit" className="btn newpagebtn">Submit</button>
                    </form>
                </div>
            </section>
            <TopBar />
        </Container>
    )
}

export default SthanUserAddCategories
